import React from "react";
import Header from "../header/Header";
import logo from "../../images/mmr-logo.png";

export default function Navbar(props) {
  const [scroll, setScroll] = React.useState(0);

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active" : "fixed-navbar";

  const navbarStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: window.innerWidth >= 1200 ? "86px" : "86px",
    zIndex: 9999,
    transition: "all 0.3s ease-in-out",
    backgroundColor: "rgba(0, 0, 0, 0.30)",
    boxShadow: scroll > 80 ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none",
  };

  return (
    <div className={className} style={navbarStyle}>
      <Header hclass={props.hclass} Logo={logo} />
    </div>
  );
}
